import React from 'react';
import { Award, Users } from 'lucide-react';
import { RevealSection } from './shared';

export const AboutSection = ({ sid, theme, txt }) => (
  <section id={sid} className="py-16 sm:py-28 bg-white" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center">
        <RevealSection direction="left">
          <div>
            <div className="inline-block mb-4 px-4 py-1.5 rounded-full text-sm font-medium" style={{ backgroundColor: `${theme.primary_color}10`, color: theme.primary_color }}>{txt('about', 'badge')}</div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-slate-900 mb-6" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>Solar <span className="gradient-text">GREEN</span> s.r.o.</h2>
            <p className="text-base md:text-lg text-slate-600 mb-6 leading-relaxed" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>{txt('about', 'text1')}</p>
            <p className="text-base md:text-lg text-slate-600 mb-8 leading-relaxed" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>{txt('about', 'text2')}</p>
            <div className="flex items-center space-x-8">
              <div className="flex items-center space-x-3 group">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ backgroundColor: `${theme.primary_color}15` }}>
                  <Award className="w-5 h-5" style={{ color: theme.primary_color }} />
                </div>
                <span className="text-slate-700 font-medium">{txt('about', 'certified')}</span>
              </div>
              <div className="flex items-center space-x-3 group">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110" style={{ backgroundColor: `${theme.primary_color}15` }}>
                  <Users className="w-5 h-5" style={{ color: theme.primary_color }} />
                </div>
                <span className="text-slate-700 font-medium">{txt('about', 'expert_team')}</span>
              </div>
            </div>
          </div>
        </RevealSection>
        <RevealSection direction="right">
          <div className="relative img-zoom rounded-2xl overflow-hidden shadow-2xl">
            <img src="https://images.unsplash.com/photo-1660330589505-9a433a742a7b?w=800&q=75&auto=format&fit=crop" loading="lazy" alt="Solar panel installation" className="w-full" />
            <div className="absolute -bottom-3 -right-3 w-24 h-24 rounded-xl -z-10" style={{ backgroundColor: theme.secondary_color, opacity: 0.3 }} />
          </div>
        </RevealSection>
      </div>
    </div>
  </section>
);
